module.exports = __webpack_public_path__ + "img/img_16.bce9984f.svg";